<template>
  <div id="hover-node-card" class="hover-node-card d-none" data-type="hoverNodeCard">
    <div class="card">
      <div class="card-header"></div>
      <div id="card-body-scrollbar" class="card-body"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HoverNodeCard',
  props: {
  },
  mounted() {
    $('#hover-node-card').draggable({
      containment: '#xit-flow-builder',
      scroll: false,
    })

    $('#card-body-scrollbar').niceScroll({
      cursorcolor: '#cddeed'
    })  
  },

  beforeDestroy() { // eslint-disable-line
    const hoverNodeCardElement = $('#hover-node-card')
    const isHoverNodeCardDraggable = hoverNodeCardElement.hasClass('ui-draggable')
    if (isHoverNodeCardDraggable) {
      hoverNodeCardElement.draggable('destroy')
    }

    const cardBodyScrollbarElement = $('#card-body-scrollbar')
    if (cardBodyScrollbarElement) {
      cardBodyScrollbarElement.getNiceScroll().remove()
    }
  }
}
</script>

<style>
.hover-node-card {
  position: absolute;
  width: 260px;
  top: 60px;
  right: 6px;
}
.hover-node-card .card {
  border: none;
  margin-bottom: 0px;
}
.hover-node-card .card-header {
  min-height: 0;
  background-color: #f0f0f0;
}
.hover-node-card .card-header,
.hover-node-card .card-body {
  padding: .50rem .80rem
}

.hover-node-card .card-body {
  color: #646464;
  font-size: .90rem;
  max-height: 280px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.hover-node-card .card-body .card-title {
  font-size: .90rem !important;
}
</style>